import { useLocation, useNavigate, Routes, Route } from "react-router-dom"
import { Box, Chip, Typography, useTheme } from "@mui/material"
import {
  LayoutDashboard, Linkedin, Users, Target, UserSearch,
  Megaphone, MessageSquare, Activity, ListChecks,
} from "lucide-react"
import { useTranslation } from "react-i18next"

import OutreachDashboard from "./components/Dashboard/OutreachDashboard"
import AccountList from "./components/Accounts/AccountList"
import ICPList from "./components/ICPs/ICPList"
import LeadList from "./components/Leads/LeadList"
import CampaignList from "./components/Campaigns/CampaignList"
import CampaignDetail from "./components/Campaigns/CampaignDetail"
import UnifiedInbox from "./components/Inbox/UnifiedInbox"

const SECTION_KEYS = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { key: "accounts", label: "LinkedIn Accounts", icon: Linkedin },
  { key: "icps", label: "ICPs", icon: Target },
  { key: "leads", label: "Leads", icon: UserSearch },
  { key: "campaigns", label: "Campaigns", icon: Megaphone },
  { key: "inbox", label: "Inbox", icon: MessageSquare },
]

const LinkedInOutreachScreen = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const pathParts = location.pathname.replace(/^\/admin\/linkedin-outreach\/?/, "").split("/").filter(Boolean)
  const activeSection = SECTION_KEYS.find((s) => s.key === pathParts[0])?.key || "dashboard"

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* Sub-navigation chips */}
      <Box sx={{
        display: "flex", gap: 1, flexWrap: "wrap", mb: 2,
        pb: 1.5, borderBottom: `1px solid ${theme.palette.divider}`,
      }}>
        {SECTION_KEYS.map(({ key, label, icon: Icon }) => {
          const isActive = key === activeSection
          return (
            <Chip
              key={key}
              icon={<Icon size={14} />}
              label={label}
              onClick={() => navigate(`/admin/linkedin-outreach/${key}`)}
              variant={isActive ? "filled" : "outlined"}
              size="small"
              sx={{
                borderRadius: "8px",
                fontWeight: isActive ? 600 : 500,
                fontSize: "0.78rem",
                bgcolor: isActive ? theme.palette.primary.main : "transparent",
                color: isActive ? "#fff" : theme.palette.text.secondary,
                borderColor: isActive ? "transparent" : theme.palette.divider,
                "&:hover": {
                  bgcolor: isActive ? theme.palette.primary.dark : theme.palette.action.hover,
                },
              }}
            />
          )
        })}
      </Box>

      {/* Content area */}
      <Box sx={{ flex: 1, overflow: "auto", minHeight: 0 }}>
        <Routes>
          <Route index element={<OutreachDashboard />} />
          <Route path="dashboard" element={<OutreachDashboard />} />
          <Route path="accounts" element={<AccountList />} />
          <Route path="icps" element={<ICPList />} />
          <Route path="leads" element={<LeadList />} />
          <Route path="campaigns" element={<CampaignList />} />
          <Route path="campaigns/:campaignId" element={<CampaignDetail />} />
          <Route path="inbox" element={<UnifiedInbox />} />
        </Routes>
      </Box>
    </Box>
  )
}

export default LinkedInOutreachScreen
